/**
 * SlamMobile - AI-Powered Biomechanics Video Analysis (v2.0)
 *
 * OpenCV-powered real-time tracking with Gemini semantic detection.
 * Uses hybrid pipeline: Gemini for initial landmark detection + OpenCV.js optical flow
 * for efficient frame-by-frame tracking. Physics-based collision detection for labels.
 *
 * Features:
 * - Sport-specific analysis modes (baseball, basketball, football, soccer, track)
 * - Real-time biomechanical landmark tracking
 * - Batman-style comic overlays (toggle-able)
 * - Physics-based label positioning with soft repulsion
 * - Player development focused insights
 */

import SlamMobileAnalyzer from '../../components/slammobile/SlamMobileAnalyzer';

const SlamMobile = () => {
  return <SlamMobileAnalyzer />;
};

export default SlamMobile;
